export const globalStyles = {
  primaryColor: "#009eb2",
  secondaryColor: "#b60017",
  lightBlue: "#9ae7f3",
  lightColor: "#e6edea",
  dark: "#52000a",
  primaryFont: "'Open Sans', sans-serif",
};
